// import { bootstrap } from 'bootstrap';
// Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.css';


import './editor.scss';
import './style.scss';